import { ThemeToggle } from '@collab/components/molecules';
import { Toasts } from '@collab/features/toasts';
import { environment } from '@collab/utils/environment';

import styles from './SimplePageLayout.module.css';

const SimplePageLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className={styles.contentWrapper}>
    <header className={styles.header}>
      <img
        src="https://www.volvocars.com/static/shared/images/volvo-wordmark-black.svg"
        alt="Volvo logo"
      />
    </header>
    {children}
    <footer className="p-24 text-center">
      <p className="micro text-secondary text-center">
        Copyright © {new Date().getFullYear()} Volvo Car Corporation (or its
        affiliates or licensors)
      </p>
      {!environment.IS_PROD && (
        <div className="mt-16">
          <ThemeToggle />
        </div>
      )}
    </footer>
    <Toasts />
  </div>
);

export default SimplePageLayout;
